import { t } from 'ttag'

import {
  ACTIONS,
  ROW_ACTIONS,
  HIRE_STATUSES,
  STATUSES_WITH_HIRE,
  getActions,
  getRowActions,
} from './model'

export const getEnhancedActions = (state, handlers) => {
  const { count, hasMoveCandidatesFeature, isAtsLocked } = state
  const { onDelete, onExport, onMove } = handlers

  const actions = getActions({ count, hasMoveCandidatesFeature })

  return actions.map(action => {
    const mapTypeToOnClick = {
      [ACTIONS.MOVE]: onMove,
      [ACTIONS.EXPORT]: onExport,
      [ACTIONS.DELETE]: onDelete,
    }

    const isLocked = action.type !== ACTIONS.EXPORT && isAtsLocked

    return {
      ...action,
      onClick: mapTypeToOnClick[action.type],
      isDisabled: count === 0,
      isLocked: isLocked,
    }
  })
}

export const getEnhancedRowActions = (state, handlers) => {
  const { candidate, hasMoveCandidatesFeature, isAtsLocked } = state
  const { onDelete, onEdit, onMove, onHire } = handlers

  const rowActions = getRowActions({
    hasMoveCandidatesFeature,
    showHireAction: STATUSES_WITH_HIRE.includes(candidate.status),
    isHired: candidate.hire_status === HIRE_STATUSES.HIRED,
  })

  return rowActions.map(action => {
    const mapTypeToOnClick = {
      [ROW_ACTIONS.EDIT]: () => onEdit({ candidate }),
      [ROW_ACTIONS.MOVE]: () => onMove({ candidate }),
      [ROW_ACTIONS.DELETE]: () => onDelete({ candidate }),
      [ROW_ACTIONS.HIRE]: () => onHire({ candidate }),
    }

    return {
      ...action,
      onClick: mapTypeToOnClick[action.type],
      isLocked: isAtsLocked,
    }
  })
}

export const getTooltipMessage = ({
  hasInterview,
  isInterviewAvailable,
}: {
  hasInterview?: boolean
  isInterviewAvailable?: boolean
}) => {
  if (!isInterviewAvailable) {
    return t`To conduct an interview you need to attach an interview template to this job position.`
  }

  if (!hasInterview) {
    return t`To conduct an interview you need to move the candidate back to the interview step.`
  }

  return null
}
